import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SaveTemplateModal = ({ isOpen, onClose, onSave, currentConfig }) => {
  const [templateName, setTemplateName] = useState('');
  const [description, setDescription] = useState('');

  const handleSave = () => {
    if (!templateName?.trim()) {
      alert('Please enter a template name');
      return;
    }

    onSave({
      name: templateName,
      description: description,
      config: currentConfig
    });

    setTemplateName('');
    setDescription('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-card border border-border rounded-2xl shadow-2xl max-w-md w-full animate-scale-in">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-xl bg-gradient-to-br from-primary to-accent shadow-lg">
              <Icon name="Save" size={20} color="white" />
            </div>
            <h3 className="text-lg font-semibold text-foreground">Save as Template</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-smooth"
          >
            <Icon name="X" size={20} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <Input
            label="Template Name"
            placeholder="e.g., Standard Web Project"
            value={templateName}
            onChange={(e) => setTemplateName(e?.target?.value)}
            required
          />

          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">Description (Optional)</label>
            <textarea
              placeholder="Add notes about when to use this template..."
              value={description}
              onChange={(e) => setDescription(e?.target?.value)}
              rows={3}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 transition-smooth resize-none"
            />
          </div>

          <div className="p-3 bg-muted/50 border border-border rounded-lg">
            <div className="text-xs font-medium text-muted-foreground mb-2">Template will include:</div>
            <div className="space-y-1 text-xs text-foreground">
              <div>• Delivery Mode: {currentConfig?.deliveryMode}</div>
              <div>• Engineers: {currentConfig?.selectedEngineers?.length} configured</div>
              <div>• Licenses: {currentConfig?.selectedLicenses?.length} configured</div>
              <div>• Materials: {currentConfig?.selectedMaterials?.length} configured</div>
              <div>• Commercial Config: {currentConfig?.config?.overhead}% / {currentConfig?.config?.targetMargin}% / {currentConfig?.config?.contingency}%</div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="default"
            iconName="Save"
            iconPosition="left"
            onClick={handleSave}
          >
            Save Template
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SaveTemplateModal;